import React from 'react'

const GreenTick = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 17C13.866 17 17 13.866 17 10C17 6.13401 13.866 3 10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17ZM13.8545 7.81692C14.1069 7.48846 14.0452 7.01761 13.7167 6.76525C13.3883 6.51288 12.9174 6.57457 12.6651 6.90303L8.94987 11.7384L7.29753 10.0374C7.00892 9.74031 6.5341 9.73342 6.23698 10.022C5.93987 10.3106 5.93298 10.7855 6.22159 11.0826L8.47016 13.3974C8.79303 13.7298 9.33564 13.6983 9.61796 13.3309L13.8545 7.81692Z"
        fill="#0F7013"
      />
    </svg>
  )
}

export default GreenTick
